import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../pipes/translate.pipe';
import { SecurityZone } from './route.service';

@Component({
  selector: 'app-inaccessible-route-dialog',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div class="route-dialog-backdrop" (click)="ok()">
      <div class="route-dialog" (click)="$event.stopPropagation()">
        <div class="route-dialog-header">
          <h4>{{ 'navigation_inaccesible_zones_modal_title' | translate }}</h4>
        </div>
        <div class="route-dialog-body security-zone-modal">
          <div class="security-zone-modal-left">
            <img src="assets/images/warning.png" />
          </div>
          <div class="security-zone-modal-right">
            <div>{{ 'navigation_inaccessible_zones_warning_msg_1' | translate }}</div>
            <div class="security-zones-title">{{ 'navigation_inaccessible_zones_warning_msg_2' | translate }}</div>
            <span *ngFor="let zone of zones; let i = index" class="security-zone-text">
              {{ zone.code }}: {{ zone.name }}<span *ngIf="i < zones.length - 1">, </span>
            </span>
          </div>
        </div>
        <div class="route-dialog-footer">
          <button class="link-btn" (click)="ok()">
            {{ 'navigation_inaccesible_zones_modal_ok_btn' | translate }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class InaccessibleRouteDialogComponent {
  @Input() zones: SecurityZone[] = [];
  @Output() confirmed = new EventEmitter<void>();

  ok(): void {
    this.confirmed.emit();
  }
}
